import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between align-center" }
const _hoisted_2 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "d-flex align-center mt-1" }
const _hoisted_6 = { class: "d-flex align-center mt-1" }
const _hoisted_7 = { class: "d-flex align-center mt-1" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-center mt-1"
}

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Ticket',
  props: {
    ticket: {}
  },
  setup(__props: any) {

const props = __props

const isBonus = computed(() => {
  // A ticket is a bonus ticket if it doesn't have a ticket relation or it's not purchased
  return !props.ticket.purchased
})

const isActive = computed(() => {
  return props.ticket.is_active
})

const formatDate = (dateString: string): string => {
  if (!dateString) return '無期限'
  const date = new Date(dateString)
  return date.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}

const formatPrice = (price: number): string => {
  return price ? `¥${price.toLocaleString()}` : '無料'
}

const getStatusText = (ticket: any): string => {
  // Bonus tickets are always valid
  if (isBonus.value) return '有効'

  if (typeof isActive.value !== 'undefined') {
    return isActive.value ? '有効' : '期限切れ'
  }
  return ''
}

const getStatusColor = (ticket: any): string => {
  // Bonus tickets are always green (success)
  if (isBonus.value) return 'success'

  if (typeof isActive.value !== 'undefined') {
    return isActive.value ? 'success' : 'error'
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "ticket-card"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(isBonus.value ? '贈られたチケット' : __props.ticket.ticket.name), 1 /* TEXT */),
                _createVNode(_component_v_chip, {
                  color: getStatusColor(__props.ticket),
                  "text-color": "white",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getStatusText(__props.ticket)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["color"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-ticket-outline", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("span", null, _toDisplayString(__props.ticket.ticket_number) + "枚", 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-calendar", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("span", null, "購入日: " + _toDisplayString(formatDate(__props.ticket.created_at)), 1 /* TEXT */)
                ]),
                (!isBonus.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_icon, {
                          size: "small",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("mdi-calendar-clock", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createElementVNode("span", null, "有効期限: " + _toDisplayString(formatDate(__props.ticket.expired_at)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_v_icon, {
                          size: "small",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("mdi-currency-jpy", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createElementVNode("span", null, "価格: " + _toDisplayString(formatPrice(__props.ticket.price)), 1 /* TEXT */)
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (isBonus.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("mdi-gift", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _cache[5] || (_cache[5] = _createElementVNode("span", null, "ボーナスチケット", -1 /* CACHED */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})